import type { ReactNode } from 'react'

interface Props {
  loading: boolean
  error: string | null
  children: ReactNode
}

/** Loading / error / content switch shared by the list pages. */
export function PageState({ loading, error, children }: Props) {
  if (error) return <p role="alert">{error}</p>
  if (loading) return <p aria-busy="true">Loading…</p>
  return <>{children}</>
}
